// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__oeE64","choiceBoxes":"toolbarselects_choiceBoxes__2q2Yd","simpleField":"toolbarselects_simpleField__2MviV"};